import { render, staticRenderFns } from "./KanbanBoardTaskListLineProject.vue?vue&type=template&id=396d66fc"
import script from "./KanbanBoardTaskListLineProject.vue?vue&type=script&lang=js"
export * from "./KanbanBoardTaskListLineProject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports